import { useEffect } from "react";

export const APP_TITLE = "SkillPanel UserManager";

/**
 * Names the browser tab after the screen, and gives the tab its old title back when it goes.
 * `appTitle` follows it; the front door passes "SkillPanel", whose entrance it is.
 */
export const useDocumentTitle = (title: string | undefined, appTitle = APP_TITLE) => {
  useEffect(() => {
    if (!title) {
      return;
    }
    const previous = document.title;
    document.title = `${title} – ${appTitle}`;
    return () => {
      document.title = previous;
    };
  }, [title, appTitle]);
};
